module.exports = __webpack_public_path__ + "static/media/scan.983c9aef.svg";